import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { ControlButton } from 'console/shared/components/buttons/control';
import { useCustomControl } from '../../provider';
import { useAnchor } from 'shared/hooks/utils';
import { useDispatch } from 'react-redux';
export const CustomControlButton = memo(function CustomControlButtonImpl(props) {
    const { online, onSendCommand } = props;
    const { action_label, is_active, loading, fail, fail_message, additional_commands } = useCustomControl();
    const dispatch = useDispatch();
    const [anchorEl, open, close] = useAnchor();
    return (_jsxs(_Fragment, { children: [_jsxs(ControlButton, { loading: loading, disabled: !online, active: is_active ?? false, fail: fail, fail_message: fail_message, onClick: onSendCommand, children: [_jsx(Typography, { component: "span", fontSize: "0.6em", fontWeight: 500, children: action_label }), additional_commands != null && additional_commands.length > 1 && (_jsx(IconButton, { size: "small", onClick: open, children: _jsx(ArrowDropDown, {}) }))] }), _jsx(Menu, { open: !!anchorEl, anchorEl: anchorEl, onClose: close, children: (additional_commands ?? []).map(({ title, action }, index) => (_jsx(MenuItem, { onClick: () => {
                        close();
                        dispatch(action());
                    }, children: title }, index))) })] }));
});
